import {
  FilterButton,
  CreateButton,
  ExportButton,
  TopToolbar
} from "react-admin";

const Actions = ({ hasFilter = true, hasCreate = true, hasExport = true, sx }) => (
  <TopToolbar sx={{ gap: 1, ...sx }}>
    {hasFilter && <FilterButton />}
    {hasCreate && <CreateButton />}
    {hasExport && <ExportButton />}
  </TopToolbar>
);

export default Actions;
